/**
 * This function is to check whether or not shirt order status need to be change due to pattern printing
 *
 * @param {Array<int>} shirtOrderStatus
 * @param {int} productionDocsReady
 * @param {int} shirtOrderStatusId
 *
 * @return {boolean}
 */
const doesShirtOrderStatusNeedChangingDueToPatternPrinting = (
    shirtOrderStatus,
    productionDocsReady,
    shirtOrderStatusId
) => {
    let changeShirtOrderStatus = false;
    if (productionDocsReady == 1) {
        changeShirtOrderStatus = false;
    }
    switch (shirtOrderStatusId) {
        case shirtOrderStatus.COLLECTOR_PRINTED:
            changeShirtOrderStatus = true;
            break;
        case shirtOrderStatus.PATTERN_PRINTED:
            changeShirtOrderStatus = true;
            break;
        case shirtOrderStatus.NEW_ORDER:
            changeShirtOrderStatus = true;
            break;
    }
    return changeShirtOrderStatus;
};

/**
 * This function is to check whether or not shirt order status need to be change due to production sheet printing
 *
 * @param {Array<int>} shirtOrderStatus
 * @param {int} productionDocsReady
 * @param {int} shirtOrderStatusId
 *
 * @return {boolean}
 */
const doesShirtOrderStatusNeedChangingDueToProductionSheetPrinting = (
    shirtOrderStatus,
    productionDocsReady,
    shirtOrderStatusId
) => {
    let changeShirtOrderStatus = false;
    if (productionDocsReady == 1) {
        changeShirtOrderStatus = false;
    }
    switch (shirtOrderStatusId) {
        case shirtOrderStatus.COLLECTOR_PRINTED:
            changeShirtOrderStatus = false;
            break;
        case shirtOrderStatus.PATTERN_PRINTED:
            changeShirtOrderStatus = false;
            break;
        case shirtOrderStatus.NEW_ORDER:
            changeShirtOrderStatus = true;
            break;
    }
    return changeShirtOrderStatus;
};

export {
    doesShirtOrderStatusNeedChangingDueToPatternPrinting,
    doesShirtOrderStatusNeedChangingDueToProductionSheetPrinting,
};
